<div class="row shipment-title shipment-box ">
  <div class="col-md-11">
    <h4><b>{{ 'pages.receivingPage.receiving' | translate }}</b></h4>
  </div>
</div>

<div class="col-md-12">
  <div class="row">
    <div class="col-md-4">
      <div class="shipment-status-box intact-status">
        <h2>{{ 'common.received' | translate }}</h2>
        <h2>{{calculateNumberOfShipment('Received')}}</h2>
      </div>
    </div>
    <div class="col-md-4">
      <div class="shipment-status-box shortage-status">
        <h2>{{ 'common.pending' | translate }}</h2>
        <h2>{{calculateNumberOfShipment('Pending')}}</h2>
      </div>
    </div>
    <div class="col-md-4">
      <div class="shipment-status-box overage-status">
        <h2>{{ 'common.overage' | translate }}</h2>
        <h2>{{calculateNumberOfShipment('Overage')}}</h2>
      </div>
    </div>
  </div>
</div>

<div class="mrgin-bottom3">
  <div class="col-md-6 mrgin-top5 mrgin-bottom3">
    <div class="input-group">
      <input style="height:38px;" type="text" class="form-control" [(ngModel)]="HAWB" [placeholder]="'common.search' | translate" (keydown.enter)="onKeydown($event)">
      <div class="input-group-btn">
        <button *ngIf="!validToReconcile" class="btn btn-primary" (click)="getAndSearchShipments()"><span><b>{{Shipments.length ==0 ? 'Start Receiving': 'Finish Receiving'}}</b></span></button>
        <button *ngIf="validToReconcile" class="btn btn-primary" data-toggle="modal" data-target="#exampleModalCenter" (click)="getAndSearchShipments()"><span><b>{{Shipments.length ==0 ? 'Start Receiving': 'Finish Receiving'}}</b></span></button>
      </div>
    </div>
  </div>
</div>

<!-- Modal -->
<div class="modal fade" id="exampleModalCenter" tabindex="-1" role="dialog" aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered" role="document" style="top:30%">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="exampleModalLongTitle">{{ 'pages.receivingPage.receivingConfirmationMsg' | translate }}</h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-primary" data-dismiss="modal">{{ 'common.no' | translate }}</button>
        <button type="button" class="btn btn-info" data-dismiss="modal" (click)="reconcileReceivedShipments()">{{ 'common.yes' | translate }}</button>
      </div>
    </div>
  </div>
</div>



<div *ngIf="Shipments.length > 0" class="responsive-table col-md-12 tble-over-flow">
  <table class="table table-striped table-bordered">
    <thead>
      <tr>
        <th>{{ 'pages.receivingPage.awb' | translate }}</th>
        <th>{{ 'pages.receivingPage.qty' | translate }}</th>
        <th>{{ 'common.status' | translate }}</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let shipment of Shipments;index as j">
        <td>
          {{shipment.AWB}}
        </td>
        <td>
          {{shipment.Pieces}}
        </td>
        <td>
          <div class="input-group-btn">
            <span class="btn {{getShipmentStatusClass(shipment.Status)}}"><span class="btn-padd"><b>{{shipment.Status}}</b></span></span>
          </div>
        </td>
      </tr>
    </tbody>
  </table>
</div>



